<template>
  <div
    v-for="product in store.bumProductList"
    :key="product.priceId"
    class="flex flex-col items-start self-stretch rounded-lg border-dashed border-gray-200"
  >
    <div
      class="flex items-center justify-between gap-2 self-stretch rounded-t-lg bg-[#fdfcbe] px-3 py-3"
    >
      <div class="flex items-center gap-2 self-stretch">
        <img :src="ArrowFlashIcon" alt="product image" class="rounded-lg" loading="lazy" />
        <input :id="product.productId" :name="product._id" :value="product._id" type="checkbox" />
        <UITextSmMedium
          :style="{
            color: '#090',
          }"
          >{{ product.headline }}</UITextSmMedium
        >
      </div>
    </div>
    <div class="flex flex-col items-start gap-2 self-stretch p-4">
      <p class="flex items-start gap-2 self-stretch">
        <span class="font-bold text-[#c30] underline">{{ product.otoHeadline }}</span>
        <span>{{ product.otoText }}</span>
      </p>
      <img
        :src="product.uploadedImage || product.image"
        alt="product image"
        class="h-auto max-w-full"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowFlashIcon from "@/assets/gif/arrow-flash-small.webp";
import { useAppStore } from "@/store/app";
import { UITextSmMedium } from "@gohighlevel/ghl-ui";

const store = useAppStore();
</script>

<style scoped>
.border-bottom {
  border-bottom: 2px solid #eaecf0;
  border-style: solid;
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
